import { api } from './client';

export type ContentMonitorView = 'deliver_user' | 'content_type' | 'sku_type';

export interface ContentMonitorRow {
  channel: string;
  ds_month: string;
  dimension_value: string;
  content_cnt: number | null;
  avg_sku_per_content: number | null;
  sku_cnt: number | null;
  acos: number | null;
  spend: number | null;
  payments_complete_value: number | null;
  spend_share: number | null;
  cpm: number | null;
  impressions: number | null;
  ctr: number | null;
  clicks: number | null;
  cpc: number | null;
  add_to_cart_rate: number | null;
  add_to_cart: number | null;
  pay_rate: number | null;
  payments: number | null;
  aov: number | null;
  gmv: number | null;
  cost_per_payment: number | null;
  spend_mom: number | null;
  impressions_mom: number | null;
  clicks_mom: number | null;
  payments_mom: number | null;
  pay_eff_delta: number | null;
  roas_delta: number | null;
  spend_ratio_factor: number | null;
  gmv_ratio_factor: number | null;
  grouping_id: number;
}

export interface ContentMonitorParams {
  view: ContentMonitorView;
  start_month: string;
  end_month: string;
  brand_id?: string;
}

export const contentMonitoringApi = {
  getData: (params: ContentMonitorParams) =>
    api.get<{ code: number; data: ContentMonitorRow[] }>('/content-monitoring/data', { params }),
};
